import React from 'react';
import { AccessibilityProvider } from '../context/AccessibilityContext';
import Navbar from './Navbar';
import Footer from './Footer';
import AccessibilityWidget from './AccessibilityWidget';

const PageLayout = ({ activeLink, children }) => {
  return (
    <AccessibilityProvider>
      <div className="min-h-screen bg-white">
        <Navbar activeLink={activeLink} />
        <main id="main-content">
          {children}
        </main>
        <Footer />
        <AccessibilityWidget />
      </div>
    </AccessibilityProvider>
  );
};

export default PageLayout;
